// src/config.js
// Suprascrie cu REACT_APP_API_BASE in .env.local (ex. https://api.webnou.ro)
export const API_BASE = process.env.REACT_APP_API_BASE || 'http://sf4.local';
export const API_ENDPOINT = `${API_BASE}/api`;
